(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.observer = new ResizeObserver(() => this.updateHeight());
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.updateHeight();
      this.observer.observe(this);

      this.fauxSearchBar = this.querySelector('.faux-search-bar');
      this.closeFauxSearchBar = this.querySelector('.header__icon--dismiss-faux-search');
      this.searchToggle = document.querySelector('.header__search-toggle');
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.fauxSearchDismissed = sessionStorage.getItem('hideFauxSearchBar') === 'true';

      this.initFauxSearchBar();
      this.initHeaderColorSwitching();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.observer.disconnect();
    }

    updateHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop + 5 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop - 5 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if (this.fauxSearchBar && this.mobileMediaQuery.matches && !this.fauxSearchDismissed) {
        if (scrollTop > this.currentScrollTop + 5) {
          // Scroll down
          this.classList.remove('show-faux-search-bar');
        } else if (scrollTop < this.currentScrollTop - 5 && scrollTop > 0) {
          // Scroll up
          this.classList.add('show-faux-search-bar');
        } else if (scrollTop <= 5) {
          // At the top of the page
          this.classList.remove('show-faux-search-bar');
        }
      }

      this.updateHeaderColor();
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    initHeaderColorSwitching() {
      if (!document.body.classList.contains('template-index')) return;
      this.refreshColorSections();
      this.updateHeaderColor();

      document.addEventListener('shopify:section:load', () => {
        this.refreshColorSections();
        this.updateHeaderColor();
      });
    }

    refreshColorSections() {
      this.colorSections = [...document.querySelectorAll('.js-header-color-marker')]
        .map((marker) => ({
          wrapper: marker.closest('.shopify-section'),
          color: marker.dataset.headerColor,
        }))
        .filter((item) => item.wrapper);
    }

    updateHeaderColor() {
      if (!this.colorSections || !this.colorSections.length) return;
      if (document.querySelector('index-scroll-group')) return;
      const testY = this.getBoundingClientRect().bottom;
      let active = null;
      for (const item of this.colorSections) {
        const rect = item.wrapper.getBoundingClientRect();
        if (rect.top <= testY) active = item;
      }
      if (active) {
        this.header.setAttribute('data-header-color', active.color);
      } else {
        this.header.removeAttribute('data-header-color');
      }
    }

    initFauxSearchBar() {
      if (!this.fauxSearchBar && !this.closeFauxSearchBar) return;

      if (this.fauxSearchDismissed) {
        this.fauxSearchBar.style.display = 'none';
      }

      this.closeFauxSearchBar.addEventListener('click', () => {
        this.classList.remove('show-faux-search-bar');
        sessionStorage.setItem('hideFauxSearchBar', 'true');
        this.fauxSearchDismissed = true;
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  class PasswordHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setHeaderHeight();
      window.matchMedia('(max-width: 749px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }
  }

  customElements.define('password-header', PasswordHeader);

  } catch(e) { console.error(e); }
})();
})();
